import { render } from "./GlobalSearch.vue?vue&type=template&id=1bb9e880&scoped=true&ts=true"
import script from "./GlobalSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSearch.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalSearch.vue?vue&type=style&index=0&id=1bb9e880&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb9e880"],['__file',"resources/js/vue/components/shared/global-search/GlobalSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bb9e880"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bb9e880', __exports__)) {
    api.reload('1bb9e880', __exports__)
  }
  
  module.hot.accept("./GlobalSearch.vue?vue&type=template&id=1bb9e880&scoped=true&ts=true", () => {
    api.rerender('1bb9e880', render)
  })

}


export default __exports__